import {
  CampaignCondition,
  CampaignConditionNewFormat,
  SelectedSchemaCondition,
} from "types/campaigns";
import { findConditionIdPath } from "../../../campaignHelpers";
import { ConditionWithCounter } from "./CommandBar";

export const popularConditionsTriggerValue = 3;

export const defaultPopularConditions: ConditionWithCounter[] = [
  {
    attribute: "customer.purchaseAmount",
    label: "totalSpendingWithCurrency",
    type: "float",
    counter: popularConditionsTriggerValue,
  },
  {
    attribute: "customer.averagePurchaseAmount",
    label: "avgTransactionValueWithCurrency",
    type: "float",
    counter: popularConditionsTriggerValue,
  },
  {
    attribute: "expression",
    label: "expression",
    operator: "expression",
    type: "expression",
    counter: popularConditionsTriggerValue,
  },
];

/**
 *
 * @param permission user's permissions
 * @param conditionsArray array of all conditions
 * @param memberDetailsArray array of Member details conditions
 * @returns filtered Trigger-based conditions array based on user's current permissions, array of all available conditions and Member details conditions
 */
export const filterTriggerBasedConditions = (
  permission: boolean,
  conditionsArray: (
    | CampaignCondition
    | SelectedSchemaCondition
    | CampaignConditionNewFormat
  )[],
  memberDetailsArray: ConditionWithCounter[],
) =>
  permission
    ? conditionsArray
        .filter(
          (condition) =>
            !memberDetailsArray.some(
              (memberCondition) =>
                findConditionIdPath(memberCondition) ===
                findConditionIdPath(condition),
            ) &&
            findConditionIdPath(condition) !== "expression" &&
            findConditionIdPath(condition) !== "transaction.channelId",
        )
        .map((condition) => ({ ...condition, counter: 0 }))
    : conditionsArray
        .filter(
          (condition) =>
            !memberDetailsArray.some(
              (memberCondition) =>
                findConditionIdPath(memberCondition) ===
                findConditionIdPath(condition),
            ) && findConditionIdPath(condition) !== "expression",
        )
        .map((condition) => ({ ...condition, counter: 0 }));

export const getMemberConditions = (
  conditions: (
    | CampaignCondition
    | SelectedSchemaCondition
    | CampaignConditionNewFormat
  )[],
  isRefferalCampaign: boolean,
  tierPermissions: boolean,
) => {
  const excludedConditions = [
    "customer.purchaseAmount",
    "referrer.purchaseAmount",
    "customer.averagePurchaseAmount",
    "referrer.averagePurchaseAmount",
    "customer.numberOfPurchases",
    "referrer.numberOfPurchases",
    "customer.blockedPoints",
    "referrer.blockedPoints",
    "customer.lastTransactionDate",
    "referrer.lastTransactionDate",
    "customer.firstTransactionDate",
    "referrer.firstTransactionDate",
    ...(!tierPermissions
      ? [
          "customer.levelId",
          "referrer.levelId",
          "customer.tiers",
          "referrer.tiers",
        ]
      : []),
  ];

  return conditions.filter((condition) => {
    const attribute = findConditionIdPath(condition);

    if (isRefferalCampaign) {
      return (
        (attribute?.includes("customer") || attribute?.includes("referrer")) &&
        !excludedConditions.includes(attribute)
      );
    }
    return (
      attribute?.includes("customer") && !excludedConditions.includes(attribute)
    );
  });
};
